import {StyleSheet} from "aphrodite";
import * as React from "react";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";
import {Dismissible} from "@repo/component-dismissible";
import {doNotTranslateYet} from "@repo/i18n";

import BaseToastNotification from "../components/base-toast-notification.tsx";

const DistrictReportLoadingNotification = (): React.ReactElement => {
    return (
        <Dismissible
            dismissKey="district-report-loading-notification"
            expiresDays="never"
            showOnce={true}
        >
            {(_) => (
                <BaseToastNotification
                    style={styles.toast}
                    closeIconColor={color.white}
                >
                    <LabelMedium>
                        {doNotTranslateYet`Reports may take up to 30 seconds to load, depending on the filter criteria.`}
                    </LabelMedium>
                </BaseToastNotification>
            )}
        </Dismissible>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: color.blue,
        color: color.white,
        width: "auto",
        paddingRight: spacing.xxLarge_48,
    },
});

export default DistrictReportLoadingNotification;
